/**
 * @generated SignedSource<<3e7788df1872efb359b780cdcd3c61f0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "searchConfigurationId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "terms"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "searchConfigurationId",
    "variableName": "searchConfigurationId"
  },
  {
    "kind": "Variable",
    "name": "terms",
    "variableName": "terms"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PageSectionSearchBoxQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Response",
        "kind": "LinkedField",
        "name": "searchResults",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Result",
            "kind": "LinkedField",
            "name": "results",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PageSectionSearchBoxQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Response",
        "kind": "LinkedField",
        "name": "searchResults",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Result",
            "kind": "LinkedField",
            "name": "results",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7e2f38e6fb747d6d7044070fc80e1067",
    "id": null,
    "metadata": {},
    "name": "PageSectionSearchBoxQuery",
    "operationKind": "query",
    "text": "query PageSectionSearchBoxQuery(\n  $searchConfigurationId: ID!\n  $terms: String!\n) {\n  searchResults(searchConfigurationId: $searchConfigurationId, terms: $terms) {\n    results {\n      label\n      value\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

node.hash = "184a21b17b0eb252ba886d32466c4fdc";

module.exports = node;
